import { Provider } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

import { MockKeycloakService } from '@core/services/mock-keycloak.service';

export const mockKeycloakServiceProvider: Provider = {
  provide: KeycloakService,
  useClass: MockKeycloakService,
};
